import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  Paragraph,
  Button,
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from '@increasecard/typed-components';

const ButtonGroup = styled.div`
  margin-bottom: 10px;
  align-items: center;
`;

type DeleteCredentialModalProps = {
  showDeleteCredentialModal: boolean;
  toggleDeleteCredentialModal: () => void;
  onDeleteCredential: () => void;
};

export default function DeleteCredentialModal({
  showDeleteCredentialModal,
  toggleDeleteCredentialModal,
  onDeleteCredential
}: DeleteCredentialModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      onCancel={toggleDeleteCredentialModal}
      onClose={toggleDeleteCredentialModal}
      onOk={toggleDeleteCredentialModal}
      visible={showDeleteCredentialModal}
    >
      <ModalHeader align="left">{t('abm:DeleteCredentialModal:title')}</ModalHeader>
      <ModalContent align="left" scrollable>
        <Paragraph>{t('abm:DeleteCredentialModal:description')}</Paragraph>
      </ModalContent>
      <ModalFooter>
        <ButtonGroup>
          <Button buttonType="primary" onClick={onDeleteCredential}>
            {t('abm:DeleteCredentialModal:delete')}
          </Button>
          <Button buttonType="invisible" onClick={toggleDeleteCredentialModal}>
            {t('abm:DeleteCredentialModal:cancel')}
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
}
